import { Carousel } from "antd";
import { E_BANNER_POSITION } from "constants/banner";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { useGetBannerList } from "services/banner";
import { IBanner } from "types/banner";

const leftBannerStyle: React.CSSProperties = {
  margin: 0,
  height: "344px",
  width: "100%",
  objectFit: "cover",
};
const rightBannerStyle: React.CSSProperties = {
  margin: 0,
  height: "170px",
  width: "100%",
  objectFit: "cover",
};

const mobileBannerStyle: React.CSSProperties = {
  margin: 0,
  height: "240px",
  width: "100%",
  objectFit: "contain",
};

const isAbsoluteUrl = (url: string): boolean => {
  return /^https?:\/\//i.test(url);
};

const HeroImage = () => {
  const isDesktop = useMediaQuery({
    query: "(min-width: 768px)",
  });
  const navigate = useNavigate();

  const { bannerList } = useGetBannerList();

  const handleBannerClick = (banner: IBanner) => {
    if (!banner.url) return;

    if (isAbsoluteUrl(banner.url)) {
      window.open(banner.url, "_blank", "noopener,noreferrer");
    } else {
      navigate(banner.url);
    }
  };

  const bannerLeft = bannerList?.filter(
    (b) => b.position === E_BANNER_POSITION.LEFT
  );

  const bannerTopRight = bannerList?.filter(
    (b) => b.position === E_BANNER_POSITION.TOP_RIGHT
  );

  const bannerBottomRight = bannerList?.filter(
    (b) => b.position === E_BANNER_POSITION.BOTTOM_RIGHT
  );

  const bannerMobile = bannerList?.filter(
    (b) => b.position === E_BANNER_POSITION.MOBILE
  );

  const onChange = (currentSlide: number) => {
    // console.log(currentSlide);
  };

  if (isDesktop) {
    return (
      <div className="flex w-full gap-1">
        <div className="w-3/5">
          {/* Left Banner  5s */}
          <Carousel
            afterChange={onChange}
            arrows
            effect="fade"
            autoplay
            autoplaySpeed={5000}
          >
            {bannerLeft?.map((item) => {
              return (
                <div
                  key={item.imageKey}
                  className={`h-[344px] ${item.url ? "cursor-pointer" : "cursor-default"}`}
                  onClick={() => handleBannerClick(item)}
                >
                  <img
                    src={item.imageKey}
                    alt={item.url}
                    style={leftBannerStyle}
                  />
                </div>
              );
            })}
          </Carousel>
        </div>
        {/* Right Banner 5s */}
        <div className="w-2/5 flex flex-col gap-1">
          <Carousel
            afterChange={onChange}
            arrows
            effect="fade"
            autoplay
            autoplaySpeed={10000}
          >
            {bannerTopRight?.map((item) => {
              return (
                <div
                  key={item.imageKey}
                  className={`h-[170px] ${item.url ? "cursor-pointer" : "cursor-default"}`}
                  onClick={() => handleBannerClick(item)}
                >
                  <img
                    src={item.imageKey}
                    alt={item.url}
                    style={rightBannerStyle}
                  />
                </div>
              );
            })}
          </Carousel>
          {/* Bottom Banner 5s */}
          <Carousel
            afterChange={onChange}
            arrows
            effect="fade"
            autoplay
            autoplaySpeed={10000}
          >
            {bannerBottomRight?.map((item) => {
              return (
                <div
                  key={item.imageKey}
                  className={`h-[170px] ${item.url ? "cursor-pointer" : "cursor-default"}`}
                  onClick={() => handleBannerClick(item)}
                >
                  <img
                    src={item.imageKey}
                    alt={item.url}
                    style={rightBannerStyle}
                  />
                </div>
              );
            })}
          </Carousel>
        </div>
      </div>
    );
  }
  return (
    <div className="flex">
      <div className="w-full">
        <Carousel afterChange={onChange} arrows>
          {bannerMobile?.map((item) => {
            return (
              <div
                key={item.imageKey}
                className={`h-[240px] ${item.url ? "cursor-pointer" : "cursor-default"}`}
                onClick={() => handleBannerClick(item)}
              >
                <img
                  src={item.imageKey}
                  alt={item.url}
                  style={mobileBannerStyle}
                />
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};
export default HeroImage;
